import sanitize from 'sanitize-html';

export default function removeHtml(html: Maybe<string>) {
  if (!html) return undefined;

  return sanitize(html, {
    allowedTags: [],
    allowedAttributes: {},
  });
}
